import { render, staticRenderFns } from "./registrar_recebimento.vue?vue&type=template&id=31dd6079"
import script from "./registrar_recebimento.vue?vue&type=script&lang=js"
export * from "./registrar_recebimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports